import {
  productTypeOptions,
  productTypes,
} from '../features/recommendations/CreateRecommend/recommendFields';

export const sanitiseProductType = (product: string): productTypeOptions | null => {
  if (productTypes.includes(product as productTypeOptions)) {
    return product as productTypeOptions;
  }
  return null;
};
